const l = {
  name: "Star",
  dimensions: { width: 40, height: 38 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 38" style="enable-background:new 0 0 40 38;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,0l6.7,11.8L40,14.5l-9.2,10L32.4,38L20,32.4L7.6,38l1.6-13.5L0,14.5l13.3-2.7L20,0z M20,4.1l-5.4,9.6
			L3.9,15.8l7.4,8.1L10,34.7l10-4.6l10,4.6l-1.3-10.9l7.4-8.1l-10.7-2.2L20,4.1z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as Star
};
